import { Box, Flex } from "@radix-ui/themes";
import { TIMELINE_ITEM_VIEW, TimelineItemView } from "./constants/timeline";

interface TimelineItemProps {
  view: TimelineItemView;
  color: string;
}

const TimelineItem = ({ view, color }: TimelineItemProps) => {
  switch (view) {
    case TIMELINE_ITEM_VIEW.TRACK:
      return (
        <Flex height="100%" width="100%" justify="center">
          <Flex
            height="100%"
            flexGrow="1"
            style={{ backgroundColor: color }}
          ></Flex>
        </Flex>
      );

    case TIMELINE_ITEM_VIEW.EVENT_RANGE:
      return (
        <Flex height="100%" width="100%" align="center">
          <Flex
            height="17px"
            flexGrow="1"
            className="border-t border-b border-black"
            style={{ backgroundColor: color }}
          ></Flex>
        </Flex>
      );

    case TIMELINE_ITEM_VIEW.EVENT:
      return (
        <Flex height="100%" width="100%" align="center" justify="center">
          <Box
            height="12px"
            width="12px"
            className="border border-black rotate-45"
            style={{ backgroundColor: color }}
          ></Box>
        </Flex>
      );
    default:
      return null;
  }
};

export default TimelineItem;
